import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import Image from 'next/image';
import { getAssetSrc, useResponsiveBreakPoints } from '@restworld/utils-common';
import { Rating, Title } from '../../';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var GoogleRatingCard = function GoogleRatingCard(_ref) {
  var rating = _ref.rating,
      description = _ref.description,
      fullWidth = _ref.fullWidth,
      googleLogoSize = _ref.googleLogoSize,
      backgroundColor = _ref.backgroundColor,
      wrapperStyle = _ref.wrapperStyle,
      ratingIconSize = _ref.ratingIconSize,
      ratingLabelSize = _ref.ratingLabelSize,
      _ref$showGoogleIcon = _ref.showGoogleIcon,
      showGoogleIcon = _ref$showGoogleIcon === void 0 ? true : _ref$showGoogleIcon;

  var _useResponsiveBreakPo = useResponsiveBreakPoints(),
      isLargeDesktop = _useResponsiveBreakPo.isLargeDesktop;

  return /*#__PURE__*/_jsxs(CardWrapper, {
    backgroundColor: backgroundColor,
    wrapperStyle: wrapperStyle,
    fullWidth: fullWidth,
    children: [showGoogleIcon ? /*#__PURE__*/_jsx(Image, _objectSpread({}, _objectSpread({
      src: getAssetSrc('/utils-assets/google-icon.svg'),
      width: isLargeDesktop ? 110 : 71,
      height: isLargeDesktop ? 40 : 24,
      alt: 'google'
    }, googleLogoSize))) : null, /*#__PURE__*/_jsxs("div", {
      className: "flex flex-row gap-2 items-center",
      children: [/*#__PURE__*/_jsx(Label, {
        ratingLabelSize: ratingLabelSize,
        htmlFor: "rating",
        children: rating
      }), /*#__PURE__*/_jsxs("div", {
        id: "rating",
        className: "flex flex-col gap-1",
        children: [/*#__PURE__*/_jsx(Rating, {
          rating: +rating,
          size: (ratingIconSize !== null && ratingIconSize !== void 0 ? ratingIconSize : isLargeDesktop) ? 'md' : 'sm'
        }), /*#__PURE__*/_jsx(Title, {
          textColor: "gray",
          fontSize: "xSmall",
          fontWeight: "normal",
          content: description
        })]
      })]
    })]
  });
};
export var CardWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "google-ratingcard__CardWrapper",
  componentId: "sc-19brag1-0"
})(function (_ref2) {
  var fullWidth = _ref2.fullWidth,
      backgroundColor = _ref2.backgroundColor,
      wrapperStyle = _ref2.wrapperStyle;
  return [{
    "marginLeft": "auto",
    "marginRight": "auto",
    "display": "flex",
    "width": "fit-content",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "gap": "1.5rem",
    "borderRadius": "0.5rem",
    "padding": "1.5rem"
  }, backgroundColor === 'white' ? {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))"
  } : {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(243 244 246 / var(--tw-bg-opacity))"
  }, wrapperStyle, fullWidth ? {
    "width": "100%"
  } : {}];
});

var Label = /*#__PURE__*/_styled.label.withConfig({
  displayName: "google-ratingcard__Label",
  componentId: "sc-19brag1-1"
})(function (_ref3) {
  var ratingLabelSize = _ref3.ratingLabelSize;
  return [ratingLabelSize === 'md' ? {
    "fontSize": "1.5rem",
    "lineHeight": "2.25rem",
    "@media (min-width: 768px)": {
      "fontSize": "2.25rem",
      "lineHeight": "3.375rem"
    }
  } : ratingLabelSize === 'xs' ? {
    "fontSize": "1rem",
    "lineHeight": "1.75rem"
  } : {
    "fontSize": "1.25rem",
    "lineHeight": "2rem"
  }, {
    "fontWeight": "600",
    "--tw-text-opacity": "1",
    "color": "rgb(17 24 39 / var(--tw-text-opacity))"
  }];
});